import React from 'react'
import { Header, Icon, Button, Image } from 'semantic-ui-react'

import '../css/org-detail.css'

export default class OrgDetail extends React.Component {
  render () {
    const { proposal } = this.props
    return (
      <div style={{ padding: '2rem' }}>
        <Header as='h2'>
          {proposal.projectTitle}
          <Header.Subheader>
            {proposal.organisationName}
            {proposal.selected == '1' && <span> &middot; Selected</span>}
          </Header.Subheader>
        </Header>
        <div className='org-detail-container'>
          <div>
            <Image
              src={proposal.orgDisplayLink}
              width='200'
              alt='proposal-1'
              style={{ padding: '2rem 0' }}
            />
          </div>
          <div className='project-description'>
            <Header as='h3' style={{ paddingBottom: '0.5rem' }}>
              Project description
            </Header>
            {proposal.projectDescription}
          </div>
        </div>
        <div className='proposal-container'>
          <Button
            as='a'
            color='blue'
            href={proposal.proposalLink}
            target='_blank'
            className='view-proposal-button'
          >
            <Icon name='file pdf outline' />
            View submitted proposal
          </Button>
        </div>
      </div>
    )
  }
}
